import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { DescriptionStep } from './Description';

async function LoadDescriptionStep(): Promise<typeof DescriptionStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-description" */ './Description'))
		.DescriptionStep;
}

export function DescriptionLoader(): JSX.Element {
	const loadComponent = useCallback(LoadDescriptionStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadDescriptionStep = LoadDescriptionStep;
